import React from 'react';

export default class Page4 extends React.Component {

    render() {

        return <div id="region-main-pad">
            <div id="region-main"><span id="user-notifications"/>
                <div className="region-content">
                    <div role="main"><span id="maincontent"/>
                        <section>
                            <div className="">
                                <div className="ilead-rgt people">
                                    <div className="innerpadding">

                                        <div className="ilead-contentarea">
                                            <div className="border_subtitle">Integrity</div>
                                            <p>This element is all about ensuring that you live out certain
                                                values. This may be about adhering to
                                                company values or behaving in line with certain personal values.
                                                An example of a common value
                                                that both organisations and individuals hold is hard work.
                                                Putting in hard work leads to success.
                                                For a role model to be effective they have to be seen to be
                                                putting in the effort in order to reap
                                                the rewards.</p>

                                            <div className="border_subtitle">Quality</div>
                                            <p>People often admire things that are of a high level of quality,
                                                such as a top-of-the-range car or a
                                                piece of craftsmanship. This focus on quality is itself
                                                considered of high value. In organisations,
                                                working to, and insisting on, high levels of quality tends to
                                                produce outstanding results. For
                                                example, if you are leading a new project you may want to ensure
                                                that people clearly understand
                                                what level of quality you expect. You could point to similar,
                                                previously undertaken tasks or projects
                                                in order to benchmark the quality levels you require. It is
                                                worth showing people how you personally
                                                will aim to reach these high standards. This enables others to
                                                see the standards that you expect
                                                and how you will adhere to these quality levels. It is then up
                                                to you to live out this plan and
                                                produce work of an extremely high quality.</p>


                                            <div className="border_subtitle">Positive behaviour</div>
                                            <p>There are many different types of role models, but all will
                                                display some form of positive behaviour.
                                                This can cover a range of different actions or activities. The
                                                important aspect is that these
                                                behaviours are linked with some form of success or value set.
                                                That is, the behaviour leads to a
                                                successful result or the approach itself sets a good example for
                                                others, regardless of the outcome.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad greennumberroundbg1">
                                                <div className="paraspace">
                                                    <p>Take the scenario of negotiating a business deal.
                                                        Examples of positive behaviours in this
                                                        situation could include:</p></div>
                                                <ul className="greenbullet-list">
                                                    <li>Sticking to a game plan for negotiating a win-win
                                                        outcome
                                                    </li>
                                                    <li>Being honest about what can and can’t be compromised
                                                    </li>
                                                    <li>Facilitating meetings to involve all parties</li>
                                                    <li className="textbottompadding">Communicating the progress
                                                        and outcomes with all stakeholders.
                                                    </li>

                                                </ul>
                                            </div>

                                            <div className="border_subtitle">Visibility</div>
                                            <p>Part of role modelling effectively is ensuring that people can
                                                see what actions and behaviour is
                                                being undertaken. Maintaining a visible profile is important to
                                                ensure that the approach can be
                                                seen by others in order for them to learn from it. This is not
                                                just about status for the sake of
                                                maintaining a certain profile but can be used to help others
                                                understand what good behaviour is,
                                                or how to conduct themselves. In this way people can better
                                                understand what success looks like
                                                and how it can be achieved.</p>
                                            <div
                                                className="lightgreencontentbg keyquestionpad greennumberroundbg1">
                                                <div className="paraspace"><p>The following pages outline two
                                                    practical tools to help you to be an effective role
                                                    model:</p></div>
                                                <ul className="greenbullet-list">
                                                    <li>Common misconceptions</li>
                                                    <li className="textbottompadding">Role model attributes
                                                        Self-analysis.
                                                    </li>

                                                </ul>
                                            </div>


                                            <div className="left-btn">
                                                <div onClick={this.props.handleChangePage('Page3')}
                                                     className="button-next-previous-done">&lt;&lt; Previous
                                                </div>
                                            </div>
                                            <div className="right-btn">
                                                <div onClick={this.props.handleChangePage('Page5')}
                                                     className="button-next-previous-done">Next &gt;&gt;</div>
                                            </div>
                                        </div>


                                    </div>

                                </div>


                            </div>


                        </section>
                    </div>
                </div>
            </div>
        </div>;
    }
}